module.exports = __webpack_public_path__ + "img/国际私法.5d048e4e.png";